var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-173 -239) translate(105 119) translate(24 112) translate(44 8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-173 -239) translate(105 119) translate(24 112) translate(44 8) translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.222,
    height: 3.556,
    x: 5.333,
    y: 14.222,
    fill: "#FFF",
    rx: 1.778
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.333 14.222L26.667 14.222 24 17.778z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection);
export default __webpack_public_path__ + "static/media/section.fd0a47f56ef70c2f57dd873e4b0cc176.svg";
export { ForwardRef as ReactComponent };